// we are using bootstrap version 4
import 'bootstrap';
import slick from 'slick-carousel/slick/slick.min.js';
require('../../bower_components/jquery.meanmenu/jquery.meanmenu.min.js');

$(document).ready(function() {

    //back to top
    $(window).on('scroll', function() {
        if ($(window).scrollTop() > 100) {
            $("#back-to-top").css("display", "block");
        } else {
            $("#back-to-top").css("display", "none");
        }
    });
    if ($('#back-to-top').length) {
        $("#back-to-top").on('click', function() {
            $('html, body').animate({
                scrollTop: $('html, body').offset().top,
            }, 1000);
        });
    }

    //popup mobile
    $('.popup-plush').click(function() {
        $(this).parent().find('.popup-content').stop(true, false).slideToggle();
    });
    
    //meanmenu
    $('.main-menu').meanmenu({
        meanScreenWidth: "992",
        meanMenuContainer: ".mobile-menu",
    });

    //menu header responsive
    $('.header-top-menu .fa').click(function(){
        $(this).parent().find('ul').css('left', '0');
        $(this).parent().find('.fa-bars').css('display', 'none');
        $(this).parent().find('.fa-times').css('display', 'block');
        $(this).parent().find('.click-responsive-menu').css('display', 'block');
    });
    $('.click-responsive-menu').click(function(){
        $(this).parent().find('ul').css('left', '-400px');
        $(this).parent().find('.fa-bars').css('display', 'block');
        $(this).parent().find('.fa-times').css('display', 'none');
        $(this).parent().find('.click-responsive-menu').css('display', 'none');     
    });

    //sidebar
    $('.aside-introduction ul > li').find('.sub-menu').parent().addClass('tamgiac');

    $('.tamgiac').click(function(){
        $(this).find('.sub-menu').slideToggle();
    });
    
    //home-banner
    $('.home-banner').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        autoplay: true,
        dots: true,
        arrows: true
    });

    //footer-grateful-content
    $('.footer-grateful-content').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        // autoplay: true,
        dots: true,
        arrows: false
    });

    $('.news-feature-recent > div').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        pauseOnHover: false,
        // autoplay: true,
        dots: false,
        arrows: true,
        responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '0px',
                }
            }
        ]
    });

});


// WEBPACK FOOTER //
// ./assets/scripts/app.js